<template>
  <!-- Persistent reminder bar shown whenever a super-admin is viewing a farm
       through a simulated role (set from the /admin Farm Manager). Fixed to
       the top so it's unmissable; one click drops back to normal admin. -->
  <div class="sim-banner">
    <span class="sim-text">
      <i class="fas fa-user-secret"></i>
      Simulating <strong>{{ $store.state.simulation.role }}</strong>
      on <strong>{{ $store.state.simulation.farmName || $store.state.simulation.farmId }}</strong>
      <span class="sim-note">— UI only; you still have full super-admin access on the backend.</span>
    </span>
    <button class="sim-exit" @click="exitSimulation">
      <i class="fas fa-times"></i> Exit simulation
    </button>
  </div>
</template>

<script>
export default {
  name: 'SimulationBanner',
  methods: {
    exitSimulation () {
      this.$store.commit('setStateProperty', {
        property: 'simulation',
        value: { active: false, role: '', farmId: '', farmName: '' }
      })
      // Back to the admin console; clearing the sim means a re-fetch of this
      // farm would resolve the super-admin's real (likely no-membership) role.
      if (this.$route.path !== '/admin') {
        this.$router.push('/admin')
      }
    }
  }
}
</script>

<style scoped>
.sim-banner {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 3000;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  background: #b8860b;
  color: #fff;
  font-size: 0.85rem;
  padding: 6px 14px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.3);
}
.sim-text { line-height: 1.3; }
.sim-text strong { font-weight: 700; }
.sim-note { opacity: 0.85; font-size: 0.78rem; }
.sim-exit {
  background: rgba(0, 0, 0, 0.25);
  border: 1px solid rgba(255, 255, 255, 0.5);
  border-radius: 5px;
  color: #fff;
  font-size: 0.8rem;
  font-weight: 600;
  padding: 4px 10px;
  cursor: pointer;
  white-space: nowrap;
  flex: 0 0 auto;
}
.sim-exit:hover { background: rgba(0, 0, 0, 0.4); }
</style>
